import { useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";

import LogoImg from "src/assets/Images/logo-img.png";
import DarkBlueLogo from "src/assets/Images/logo-dark-blue.png";

import { PATH_DASHBOARD } from "src/routes/paths";
import useOffSetTop from "src/hooks/useOffSetTop";
import { AHidden } from "src/components/@material-extend";
import navConfig from "./MenuConfig";
import MenuCommon from "./MenuCommon";
import MenuDesktop from "./MenuDesktop";
import MenuMobile from "./MenuMobile";

export const APP_BAR_MOBILE = 56;
export const APP_BAR_DESKTOP = 64;

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: "auto",
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create(["height", "background-color"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up("md")]: {
    height: APP_BAR_DESKTOP,
  },
}));

const ToolbarShadowStyle = styled("div")(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: "auto",
  borderRadius: "50%",
  position: "absolute",
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8,
}));

export default function MainAppBar({ mode = "dark" }) {
  const isOffset = useOffSetTop(20);
  const navigate = useNavigate();
  const isDark = mode === "dark";

  return (
    <AppBar
      sx={{
        boxShadow: 0,
        backgroundImage: "none",
        bgcolor: "transparent",
      }}
    >
      <ToolbarStyle
        disableGutters
        sx={{
          px: 0,
          ...(isOffset && {
            bgcolor: isDark ? "background.default" : "common.white",
          }),
        }}
      >
        <Container
          maxWidth="xxl"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <AHidden width="mdDown">
            <Box
              component="img"
              src={isDark ? LogoImg : DarkBlueLogo}
              onClick={() => navigate(PATH_DASHBOARD.home)}
              sx={{
                mr: { md: 4, lg: 8, xl: 10 },
                width: 150,
                height: 50,
                cursor: "pointer",
              }}
            />
          </AHidden>

          <AHidden width="mdDown">
            <MenuDesktop navConfig={navConfig} isDark={isDark} />
          </AHidden>

          <AHidden width="mdUp">
            <MenuMobile navConfig={navConfig} isDark={isDark} />
          </AHidden>

          <Box flexGrow={1} />

          <MenuCommon isDark={isDark} />
        </Container>
      </ToolbarStyle>
      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}

export { ToolbarShadowStyle, ToolbarStyle };
